module.exports = {
    clientType : 11,
    domain : "//passport.huize.com",
    apiPrefix : "/api",
    logo : {
        src : "//activities.huizecdn.com/hz/www/upload/2019/0704/logo.gif",
        link : "//www.huize.com",
        title : '慧择保险网',
    },
    // registerBg : "//activities.huizecdn.com/hz/www/upload/2018/0809/drw_login.jpg",//注册页背景图
    // registerBg : "//activities.huizecdn.com/hz/www/upload/2018/1030/double-eleven-login.jpg",//注册页背景图
    registerBg:
    "//activities.huizecdn.com/hz/www/upload/2019/0227/daerwen-login.jpg" //注册页背景图

}



// WEBPACK FOOTER //
// ./src/config/www/production.js